import { render, staticRenderFns } from "./Underage.vue?vue&type=template&id=086d1576&scoped=true"
import script from "./Underage.vue?vue&type=script&lang=js"
export * from "./Underage.vue?vue&type=script&lang=js"
import style0 from "./Underage.vue?vue&type=style&index=0&id=086d1576&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "086d1576",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/nodejs-standardization-global-v2.0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('086d1576')) {
      api.createRecord('086d1576', component.options)
    } else {
      api.reload('086d1576', component.options)
    }
    module.hot.accept("./Underage.vue?vue&type=template&id=086d1576&scoped=true", function () {
      api.rerender('086d1576', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/oauthFPX/Underage.vue"
export default component.exports